<template>
    <div class="audio">
        <!---s-bt-audio-->
        <img v-if="audioPlaying" class="p1_diaudio" @click="stop" src="@/assets/p1/images/imgaudio.png"
                referrerpolicy="no-referrer" />
        <!---s-bt-audio-off-->
        <img v-else class="p1_diaudiooff" @click="start" src="@/assets/p1/images/imgaudio-off.png"
                referrerpolicy="no-referrer" />
                
        <audio ref="bgm" autoplay="autoplay" loop="loop">
            <source src="//r2cdn-game.r2games.com.cn/gamesite/myheroes/4thac/BGM_witch_house.mp3" type="audio/mpeg">
        </audio>
    </div>
</template>

<style scoped>
@import "../../assets/p1/css/s1.css";
</style>
<script>

export default {
    name: 'MyAudio',
    data() {
        return {
            audioPlaying: true,
        };
    },

    methods: {
        start() {
            document.removeEventListener('touchstart', this.start);
            this.$refs.bgm.play()
            this.audioPlaying = true;
        },
        stop() {
            this.$refs.bgm.pause()
            this.audioPlaying = false;
        },
    },
    mounted() {
        document.addEventListener('touchstart', this.start);
    },
};
</script>
<!-- <style scoped>
/*-s-bt-audio*/
.diaudio {
    height: 0.860rem;
    width: 0.830rem;
}

/*-s-bt-audio-off*/
.diaudiooff {
    height: 0.860rem;
    width: 0.830rem;
}
</style> -->